import { Pipe, PipeTransform } from "@angular/core";
import { tzName } from "@date-fns/tz";

@Pipe({ name: "tzDate", standalone: true, pure: true })
export class TzDatePipe implements PipeTransform {
    transform(value: string | Date | null | undefined, timezone: string): string {
        if (!value) return "";
        const date = new Date(value);
        const datePart = new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            timeZone: timezone
        }).format(date);
        const timePart = new Intl.DateTimeFormat("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
            timeZone: timezone
        }).format(date);
        return `${datePart} ${timePart} ${tzName(timezone, date, "short")}`;
    }
}
